import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, CardContent, Stack, Typography, Checkbox, TextField } from '@mui/material';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';

const WRReservationDataForm = ({ formik }) => {
  const { module, seasonYear } = useSelector(state => state.app);

  return (
    <form onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box display="flex" flexDirection="column" justifyContent="space-between" mt={1} width="100%">
        <Card>
          <CardContent>
            <Stack direction="row">
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 50%">
                <Typography variant="subtitle2">Źródło oferty</Typography>
                <TextField id="source_of_offer" name="source_of_offer" placeholder="źródło oferty" size="small" sx={{ flexGrow: 0.98 }} value={formik.values.source_of_offer} onChange={formik.handleChange}/>
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 50%">
                <Typography variant="subtitle2">Forma komunikacji</Typography>
                <TextField id="form_of_communication" name="form_of_communication" placeholder="forma komunikacji" size="small" sx={{ flexGrow: 1 }} value={formik.values.form_of_communication} onChange={formik.handleChange}/>
              </Stack>
            </Stack>
            <Box height={20}/>
            <Stack direction="row" spacing={2}>
              <Stack>
                <Box height={20}/>
                <Stack direction="row" justifyContent={'space-around'}>
                  <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                    <Checkbox
                      id="return_agreement"
                      name="return_agreement"
                      checked={formik.values.return_agreement}
                      onChange={formik.handleChange}
                      disabled />
                    <Typography variant="subtitle2">Zwrot umowy</Typography>
                  </Stack>
                  {/* <Box sx={{ flex: '1 1 80%' }} /> */}
                </Stack>
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                {module != 'zielone_szkoly'
                  ? <TextField
                    maxWidth
                    id="reservation_notes"
                    name="reservation_notes"
                    placeholder="Uwagi odnośnie rezerwacji"
                    value={formik.values.reservation_notes} onChange={formik.handleChange}
                    multiline
                    rows={4}
                    sx={{ minWidth: '600px' }}

                  />
                  : null}
              </Stack>
            </Stack>
            {/* <Box height={20}/>
            <Stack direction="row">
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                <Checkbox id="annex_return" name="annex_return" checked={formik.values.annex_return} onChange={formik.handleChange}/>
                <Typography variant="subtitle2">Zwrot aneksu</Typography>
              </Stack>
              <Box sx={{ flex: '1 1 80%' }} />
            </Stack> */}
            <Box height={20}/>
            <Stack direction="column">
              <Stack direction="row">
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                  <Checkbox id="accommodated" name="accommodated" checked={formik.values.accommodated} onChange={formik.handleChange}/>
                  <Typography variant="subtitle2">Zakwaterowano</Typography>
                </Stack>
                <Box sx={{ flex: '1 1 80%' }} />
              </Stack>
            </Stack>
            <Box height={20}/>
            <Stack direction="column">
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                <Checkbox id="rodo_terms" name="rodo_terms" checked={formik.values.rodo_terms} onChange={formik.handleChange}/>
                <Typography variant="subtitle2">RODO - akceptacja warunków</Typography>
              </Stack>
              { seasonYear >= 2025 && <>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                  <Checkbox id="marketing_consents_email" name="marketing_consents_email" checked={formik.values.marketing_consents_email} onChange={formik.handleChange} />
                  <Typography variant="subtitle2">Akceptacja zgód marketingowych e-mail</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                  <Checkbox id="marketing_consents_sms" name="marketing_consents_sms" checked={formik.values.marketing_consents_sms} onChange={formik.handleChange} />
                  <Typography variant="subtitle2">Akceptacja zgód marketingowych SMS/MMS</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                  <Checkbox id="marketing_consents_phone" name="marketing_consents_phone" checked={formik.values.marketing_consents_phone} onChange={formik.handleChange} />
                  <Typography variant="subtitle2">Akceptacja zgód marketingowych rozmowa tel.</Typography>
                </Stack>
              </>}
              {module == 'zielone_szkoly' && seasonYear < 2026 && <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
                <Checkbox id="other_terms" name="other_terms" checked={formik.values.other_terms} onChange={formik.handleChange} />
                <Typography variant="subtitle2">Akceptacja zgód marketingowych</Typography>
              </Stack> }
            </Stack>
            <Box height={20}/>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2">Kod rabatowy</Typography>
              <TextField id="discount_code" name="discount_code" placeholder="kod rabatowy" size="small" sx={{ flexGrow: 1 }} value={formik.values.discount_code} onChange={formik.handleChange} />
            </Stack>
            {module === 'polkolonie'
              ? <>
                <Box height={20}/>
                <Stack direction="row">
                  <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1  1 20%">
                    <Checkbox id="canoeing_activities" name="canoeing_activities" checked={formik.values.canoeing_activities} onChange={formik.handleChange}/>
                    <Typography variant="subtitle2">Udział w zajęciach kajakarskich</Typography>
                  </Stack>
                  <Box sx={{ flex: '1 1 80%' }} />
                  <Box height={20} />
                  <Stack direction="column" alignItems="left" justifyContent="right" spacing={1}>
                    <Typography variant="subtitle2">Rodzaj promocji dla przyjaciół</Typography>
                    <SmallFormTextField
                      sx={{ width: 200 }}
                      select
                      name="friends_promotion_choice"
                      placeholder=""
                      options={[{ value: 'discount', label: 'Rabat' }, { value: 'gadget', label: 'Gadźet' }]}
                      value={formik.values.friends_promotion_choice}
                      onChange={e => formik.handleChange(e)}
                    />
                  </Stack>
                </Stack>
              </>
              : null}
          </CardContent>
        </Card>
      </Box>
    </form>
  );
};


export default WRReservationDataForm;
